export default "__VITE_ASSET__DKGmvry1__"